<template>
<div class="pure-menu pure-menu-horizontal header">
  <h1 class="pure-menu-heading header__title"><a href="/">{{appTitle}}</a></h1>
  <ul class=" pure-menu-list header__menu-links">
    <li class="pure-menu-item" v-if="user" v-bind:class="{ 'pure-menu-selected': isCalendarVisible }">
      <a class="pure-menu-link" v-on:click="toggleCalendar" title="Calendar">
        <i class="icon-calendar"></i>
      </a>
    </li>
    <li class="pure-menu-item">
      <a class="pure-menu-link" v-if="user" href="/logout" title="Logout"><i class="icon-logout"></i></a>
    </li>
  </ul>
</div>
</template>
<script type="text/javascript">
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "header",
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters([
      "user",
      "isCalendarVisible",
      "appTitle",
    ]),
  },
  methods: {
    ...mapMutations([
      "toggleCalendar",
    ]),
  },
};
</script>
<style lang="scss">
.header {
  position: relative;
}
.header__title {
  font-size: 1em;
  a {
    text-decoration: none;
    text-transform: none;
    color: #333;
  }
}
.header__menu-links {
  position: absolute;
  right: 0.5em;
  margin: 0.67em 0;
}
</style>



// WEBPACK FOOTER //
// Header.vue?3158cd74